import { Row, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import { FC } from 'react';
import { TableV1 } from '../../../components/Table/TableV1';
import { DealWithTimeLogs } from '../../../types';
import { useOpChargeSummarySubTableColumns } from '../hooks/useOpChargeSummarySubTableColumns';

interface Props {
  row: Row<DealWithTimeLogs>;
}

export const OpChargeSummarySubTable: FC<Props> = ({ row }) => {
  const columns = useOpChargeSummarySubTableColumns();

  const table = useReactTable({
    data: row.original.dealTimeLogs ?? [],
    columns,
    enableSorting: true,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <TableV1
      table={table}
      height='auto'
      isLastColumnSticky={false}
      hasHeader={false}
      wrapperStyle={{
        maxHeight: 'calc(100vh - 288px)',
        overflowX: 'scroll',
        border: 'none',
      }}
    />
  );
};
